import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// Design-system base styles MUST load before component CSS so that 
// component-level overrides win the cascade without !important. 
import './App.css';
import Navbar      from './components/Navbar';
import Footer      from './components/Footer';
import AIChatbot   from './components/AIChatbot';
import ScrollToTop from './components/ScrollToTop';
import Home          from './pages/Home';
import Products      from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Contact       from './pages/Contact';
import Wishlist      from './pages/Wishlist';
import Cart          from './pages/Cart';
import NotFound      from './pages/NotFound';
import ComingSoon    from './pages/ComingSoon';
import { WishlistProvider } from './contexts/WishlistContext';
import { CartProvider }     from './contexts/CartContext';

// Temporary site-wide gate. Set REACT_APP_COMING_SOON=true in env/.env or
// env/.env.production to show only the ComingSoon page for every route —
// flip it back to unset/false to restore the real site. No other code
// changes needed either way.
const COMING_SOON = process.env.REACT_APP_COMING_SOON === 'true';

const App: React.FC = () => {
  if (COMING_SOON) return <ComingSoon />;

  return (
    <WishlistProvider>
      <CartProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div className="app">
            <ScrollToTop />
            <Navbar />
            <main>
              <Routes>
                <Route path="/"                    element={<Home />} />
                <Route path="/products"            element={<Products />} />
                <Route path="/products/:category"  element={<Products />} />
                <Route path="/product/:id"         element={<ProductDetail />} />
                <Route path="/wishlist"            element={<Wishlist />} />
                <Route path="/cart"                element={<Cart />} />
                <Route path="/contact"             element={<Contact />} />
                {/* Old WooCommerce-era URLs still lingering in Google's crawl history
                    from a prior site on this domain — send them somewhere real
                    instead of the generic 404 shell. */}
                <Route path="/shop/*"               element={<Navigate to="/" replace />} />
                <Route path="/product-category/*"   element={<Navigate to="/" replace />} />
                {/* Old site's homepage also accepted these shop-filter query params
                    directly on index.html — same dead-site history, different path. */}
                <Route path="/index.html"           element={<Navigate to="/" replace />} />
                {/* WordPress-era paths from the same prior site (wp-admin, theme/plugin
                    asset paths) — still showing up in crawl history / bot probes. */}
                <Route path="/wp-admin/*"           element={<Navigate to="/" replace />} />
                <Route path="/wp-content/*"         element={<Navigate to="/" replace />} />
                <Route path="/wp-includes/*"        element={<Navigate to="/" replace />} />
                <Route path="*"            element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <AIChatbot />
          </div>
        </BrowserRouter>
      </CartProvider>
    </WishlistProvider>
  );
};

export default App;
